import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-02/lesson-24/task-01";

const task: Slide = {
  title: "Connect the following types of listening experiments to its description.",
  description: "Connect with lines.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
